"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var helpers_1 = require("@hawkins/helpers");
var displayName = 'Icon';
/**
 * A simple container for an SVG based icon. It can be either styled
 * using inline props (height and fill) or by css via className.
 *
 * Generally you will want to use a specific icon such as `<IconUser />`
 *
 * If rendered inside a `<HawkinsProvider>`, the color and the size of the icon will adapt to the theme.
 * It's possible to use icons without a `HawkinsProvider`, if doing so you will need to specify
 * the height and color either via the props or className.
 */
exports.Icon = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    // Props
    var _b = (0, helpers_1.useProps)(displayName, props), className = _b.className, fill = _b.fill, height = _b.height, layout = _b.layout, _c = _b.size, size = _c === void 0 ? 'standard' : _c, styleProp = _b.style, restProps = __rest(_b, ["className", "fill", "height", "layout", "size", "style"]);
    // Styles
    var topLevelLayoutProps = react_1.default.useMemo(function () { return ({ color: fill, fill: fill, height: height }); }, [fill, height]);
    var style = (0, helpers_1.useLayoutProps)({ layout: layout, style: styleProp, topLevelLayoutProps: topLevelLayoutProps });
    var rootClassName = (0, clsx_1.default)('Hawkins-Icon', className, {
        'Hawkins-Icon-Jumbo': size === 'jumbo',
        'Hawkins-Icon-Large': size === 'large',
        'Hawkins-Icon-Small': size === 'small',
        'Hawkins-Icon-Standard': size === 'standard',
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(__assign({ className: rootClassName, ref: ref, size: size, style: style }, restProps)) }));
});
exports.Icon.displayName = displayName;
//# sourceMappingURL=icon.js.map